const MIN_PASSWORD_LENGTH_REQUIRED = 8;

export const passwordValid = (password) => {
  const requiredLength = password.length >= MIN_PASSWORD_LENGTH_REQUIRED;
  const hasNumbers = /\d/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasSpecialCharacters = /[!@#$%^&*(),.?":{}|<>_-]/.test(password);

  return requiredLength && hasNumbers && hasLowercase && hasUppercase && hasSpecialCharacters;
};
